import React from "react";
import { makeStyles } from "@material-ui/core";
import { columns } from "./thead";
import ThbodyCustom from './thBody';

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";


let useStyles = makeStyles((theme) => ({

}))

export default function Index({ data , stock , setStock }) {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <Paper className={classes.gridTable}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column, ind) => (
                                    <TableCell
                                        key={ind}
                                        align="center"
                                        style={{ width: 160, fontWeight: "bold" }}
                                        className="target"
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object?.keys(data)?.map((key, index) => (
                                <ThbodyCustom
                                    key={index}
                                    index={index}
                                    info={data[key]}
                                    stock={stock}
                                    setStock={setStock}
                                />
                            ))}
                        </TableBody>
                    </Table>
                    {Object?.keys(data)?.lenght === 0 && (
                        <div className={classes.noData}>دیتایی برای نمایش وجو ندارد</div>
                    )}
                </TableContainer>
            </Paper>
        </div>)
}
